import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

import SelectionCompetitors from "../../components/SelectionCompetitors/SelectionCompetitors";
import AddNewBrandLayout from "../../layout/AddNewBrandLayout/AddNewBrandLayout";
import { ERoutes } from "../../constants/routes";
import { selectAddNewBrandBrandState, selectAddNewBrandCompetitorsState, selectAddNewBrandLoadingState } from "../../store/selectors/brands";
import { Company } from "../../store/auth/types";
import { createNewBrand, fetchAddNewBrandCompetitors, setAddNewBrandSelectedCompetitors } from "../../store/brands/slice";
import { CompetitorWithLogo } from "../../types/competitor";

import styles from "./AddNewBrandCompetitors.module.css";



const AddNewBrandCompetitorsView: FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const brand = useSelector(selectAddNewBrandBrandState);
  const competitorsState = useSelector(selectAddNewBrandCompetitorsState);
  const loading = useSelector(selectAddNewBrandLoadingState);



  useEffect(() => {
    if (!brand) navigate(ERoutes.AddNewBrand);
  }, [brand]);


  const handleSubmit = (selectedCompetitors: CompetitorWithLogo[]) => {
    dispatch(setAddNewBrandSelectedCompetitors(selectedCompetitors));
    dispatch(createNewBrand());
    navigate(ERoutes.Brands);
  };

  const handleFetchCompetitors = (company: Company) => {
    dispatch(fetchAddNewBrandCompetitors(company));
  }


  return (
    <AddNewBrandLayout title="Industry Competitors" linkBack={ERoutes.AddNewBrand}>
      <SelectionCompetitors
        styleLoading="dark"
        loading={loading}
        competitors={competitorsState || null}
        onReroll={() => handleFetchCompetitors(brand as Company)}
        classNameHeader={styles.step2__header} 
        classNameTitle={styles.step2__title} 
        classNameCaption={styles.step2__caption} 
        textButton="Add new brand"
        typeButton="outline-green"
        onSubmit={handleSubmit}
      />
    </AddNewBrandLayout>
  );
};

export default AddNewBrandCompetitorsView;
